import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";


import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import RequestHeader from './RequestHeader';
import TransactionComment from './TransactionComment';

import AsyncSelect from 'react-select/async';
import * as Picklist from '../Picklist';

function AddDetails(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [entityType, setEntityType] = useState(sessionStorage.entityType);

    const [userRight, setUserRight] = useState([]);

    const [reqData, setReqData] = useState([]);
    const [remark, setRemark] = useState("");

    const [reqProductType, setReqProductType] = useState(1);
    const [ddReqProductTypeOptions, setDdReqProductTypeOptions] = useState([]);

    const [reqPan, setReqPan] = useState("");
    const [reqNameOnPan, setReqNameOnPan] = useState("");


    const [reqPurpose, setReqPurpose] = useState("0");
    const [ddReqPurposeOptions, setDdReqPurposeOptions] = useState([]);

    const [reqSubPurpose, setReqSubPurpose] = useState("0");
    const [ddReqSubPurposeOptions, setDdReqSubPurposeOptions] = useState([]);


    const [reqRemitterType, setReqRemitterType] = useState("I");


    const [reqRemitterName, setReqRemitterName] = useState("");
    const [reqRemitterDob, setReqRemitterDob] = useState(new Date());
    const [reqRemitterAddress, setReqRemitterAddress] = useState("");
    const [reqRemitterIdType, setReqRemitterIdType] = useState("0");
    const [reqRemitterIdNo, setReqRemitterIdNo] = useState("");
    const [reqRemitterOccupation, setReqRemitterOccupation] = useState("");
    const [reqRemitterAnnualIncome, setReqRemitterAnnualIncome] = useState("");
    const [reqRemitterCity, setReqRemitterCity] = useState("");

    const [reqBenCountry, setReqBenCountry] = useState("");
    const [ddReqBenCountryOptions, setDdReqBenCountryOptions] = useState([]);

    const [reqBenCity, setReqBenCity] = useState("");


    const [reqBeneBank, setReqBeneBank] = useState("");
    const [reqBeneBankAcct, setReqBeneBankAcct] = useState("");
    const [reqBeneBankAdd, setReqBeneBankAdd] = useState("");
    const [reqBeneBankCountry, setReqBeneBankCountry] = useState("");
    const [reqBeneIbanNo, setReqBeneIbanNo] = useState("");
    const [reqBeneRoutingNo, setReqBeneRoutingNo] = useState("");
    const [reqBeneSortCode, setReqBeneSortCode] = useState("");
    const [reqBeneBsbNo, setReqBeneBsbNo] = useState("");
    const [reqBeneSwiftCode, setReqBeneSwiftCode] = useState("");
    const [reqBeneTransitNo, setReqBeneTransitNo] = useState("");
    const [reqBeneType, setReqBeneType] = useState("I");
    const [reqBeneName, setReqBeneName] = useState("");
    const [reqBeneAdd, setReqBeneAdd] = useState("");
    const [reqStudentDetail, setReqStudentDetail] = useState("");
    const [reqOtherDetail, setReqOtherDetail] = useState("");
    const [reqCorresBankName, setReqCorresBankName] = useState("");
    const [reqCorresBankAcctNo, setReqCorresBankAcctNo] = useState("");
    const [reqCorresBankCountry, setReqCorresBankCountry] = useState("0");
    const [ddReqCorresBankCountryOptions, setDdReqCorresBankCountryOptions] = useState([]);
    const [reqCorresBankAdd, setReqCorresBankAdd] = useState("");
    const [reqTotalReceivable, setReqTotalReceivable] = useState(0);
    const [reqTotalReceived, setReqTotalReceived] = useState(0);

    const [payListData, setPayListData] = useState([]);
    const [reqPayBankCode, setReqBankCode] = useState("0");
    const [ddReqPayBankOptions, setDdReqPayBankOptions] = useState([]);
    const [reqPayBankName, setReqBankName] = useState("");
    const [reqPayBankRefNo, setReqPayBankRefNo] = useState("");
    const [reqPayBankAmnt, setReqPayBankAmnt] = useState(0);
    const [reqPayBankDate, setReqPayBankDate] = useState(new Date());


    const [reqDocVerify, setReqDocVerify] = useState("U");
    const [reqDocId, setReqDocId] = useState("0");
    const [ddReqDocOptions, setDdReqDocOptions] = useState([]);
    const [reqDocRemark, setReqDocRemark] = useState("");
    const [docListData, setDocListData] = useState([]);


    const [reqAddDetailsFinal, setReqAddDetailsFinal] = useState(0);
    const [reqAddPaymentFinal, setReqAddPaymentFinal] = useState(0);
    const [reqDocumentsFinal, setReqDocumentsFinal] = useState(0);

    const [fxTranNo, setFxTranNo] = useState("");
    const [backOfficeData, setBackOfficeData] = useState([]);
    const [orderDate, setOrderDate] = useState("");

    const [showFetchTransaction, setShowFetchTransaction] = useState(false);

    const [zenRefNo, setZenRefNo] = useState("");
    const [zenRefData, setZenRefData] = useState([]);
    const [showFetchZenEremit, setShowFetchZenEremit] = useState(false);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);

    const [showConfirmBox, setShowConfirmBox] = useState(false);

    const [reqBranch, setReqBranch] = useState("0");
    const [reqReference, setReqReference] = useState("S");

    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);

    const [reqAgentLocation, setReqAgentLocation] = useState("0");
    const [ddReqAgentLocationOptions, setDdReqAgentLocationOptions] = useState([]);

    const [reqLoanAccountNo, setReqLoanAccountNo] = useState([]);
    const [reqLoanApplicant, setReqLoanApplicant] = useState([]);
    const [reqLoanApplicantPassport, setReqLoanApplicantPassport] = useState([]);
    const [reqLoanApplicantPan, setReqLoanApplicantPan] = useState([]);
    const [reqLoanCoApplicant, setReqLoanCoApplicant] = useState([]);
    const [reqLoanCoApplicantPassport, setReqLoanCoApplicantPassport] = useState([]);
    const [reqLoanCoApplicantPan, setReqLoanCoApplicantPan] = useState([]);



    const [reqAgentFlatCommission, setReqAgentFlatCommission] = useState(0);

    const [reqPanFatherName, setReqPanFatherName] = useState("");
    const [reqCoverBank, setReqCoverBank] = useState("");

    const [leadValue, setLeadValue] = useState(null);
    const [leadNo, setLeadNo] = useState("0");

    const [pickedAgent, setPickedAgent] = useState(null);
    const [agentGroup, setAgentGroup] = useState(0);
    const [agentAccount, setAgentAccount] = useState(0);

    const [pickedExecutive, setPickedExecutive] = useState(null);
    const [orderRepData, setOrderRepData] = useState([]);
    const [orderRepIndData, setOrderRepIndData] = useState([]);

    const [reqAgentCover, setReqAgentCover] = useState(0);
    const [reqOurMarginInPaisa, setReqOurMarginInPaisa] = useState(0);

    const [reqAgentCommissionType, setReqAgentCommissionType] = useState("F");
    const [reqAgentCommssionPiasa, setReqAgentCommssionPiasa] = useState(0);
    const [reqAgentCommssionFlat, setReqAgentCommssionFlat] = useState(0);
    const [reqSellRate, setReqSellRate] = useState(0);
    const [reqIssuerCoverRate, setReqIssuerCoverRate] = useState(0);
    const [reqTotalMarginInRs, setReqTotalMarginInRs] = useState(0);
    const [reqQuantity, setReqQuantity] = useState(0);

    const [reqAgentCommssionBankCharges, setReqAgentCommssionBankCharges] = useState(0);
    const [reqAgentCommssionNostroCharges, setReqAgentCommssionNostroCharges] = useState(0);

    const [agentCommissionOpenBlockedFlag, setAgentCommissionOpenBlockedFlag] = useState("BLOCKED");
    const [nFile, setNFile] = useState("");
    const [uploadedDocList, setUploadedDocList] = useState([]);
    const [paxlist, setPaxList] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'ADDDETAILS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);

                        setReqData(resp1);
                        setReqCoverBank(resp1.req_coverbank);
                        setReqAddDetailsFinal(resp1.req_adddetailsfinal);

                        setReqProductType(resp1.req_producttype);
                        setReqPurpose(resp1.req_purpose);
                        setReqSubPurpose(resp1.req_subpurpose);
                        setReqBranch(resp1.req_brnno);

                        setReqPan(resp1.req_pan);
                        setReqNameOnPan(resp1.req_nameonpan);

                        onChangeRefrence(resp1.req_type);
                        setReqAgent(resp1.req_agentno);
                        onChangeAgent(resp1.req_agentno);


                        setReqRemitterType(resp1.req_remittertype);
                        setReqRemitterName(resp1.req_remittername);
                        if (resp1.req_remitterdob !== null) {
                            setReqRemitterDob(new Date(resp1.req_remitterdob));
                        }
                        setReqPanFatherName(resp1.req_panfathername);
                        setReqRemitterAddress(resp1.req_remitteraddress);
                        setReqRemitterIdType(resp1.req_remitteridtype);
                        setReqRemitterIdNo(resp1.req_remitteridno);
                        setReqRemitterOccupation(resp1.req_remitteroccupation);
                        setReqRemitterAnnualIncome(resp1.req_remitterannualincome);
                        setReqRemitterCity(resp1.req_remittercity);

                        setReqBenCountry(resp1.req_benecountry);
                        setReqBenCity(resp1.req_benecity);
                        setReqBeneBank(resp1.req_benebank);
                        setReqBeneBankAcct(resp1.req_benebankacct);
                        setReqBeneBankAdd(resp1.req_benebankadd);
                        setReqBeneBankCountry(resp1.req_benebankcountrycode);
                        setReqBeneIbanNo(resp1.req_beneibanno);
                        setReqBeneRoutingNo(resp1.req_beneroutingno);
                        setReqBeneSortCode(resp1.req_benesortcode);
                        setReqBeneBsbNo(resp1.req_benebsbno);
                        setReqBeneSwiftCode(resp1.req_beneswiftcode);
                        setReqBeneTransitNo(resp1.req_benetransitno);
                        setReqBeneType(resp1.req_benetype);
                        setReqBeneName(resp1.req_benename);
                        setReqBeneAdd(resp1.req_beneadd);
                        setReqStudentDetail(resp1.req_studentdetail);
                        setReqOtherDetail(resp1.req_otherdetail);
                        setReqCorresBankName(resp1.req_corresbankname);
                        setReqCorresBankAcctNo(resp1.req_corresbankacctno);
                        setReqCorresBankCountry(resp1.req_corresbankcountry);
                        setReqCorresBankAdd(resp1.req_corresbankadd);
                        setReqAddPaymentFinal(resp1.req_paymentfinal);
                        setReqDocumentsFinal(resp1.req_documentsfinal);
                        setReqDocVerify(resp1.req_docverify);

                        setReqLoanAccountNo(resp1.req_loanaccountno);
                        setReqLoanApplicant(resp1.req_loanapplicant);
                        setReqLoanApplicantPassport(resp1.req_loanapplicantpassport);
                        setReqLoanApplicantPan(resp1.req_loanapplicantpan);
                        setReqLoanCoApplicant(resp1.req_loancoapplicant);
                        setReqLoanCoApplicantPassport(resp1.req_loancoapplicantpassport);
                        setReqLoanCoApplicantPan(resp1.req_loancoapplicantpan);

                        setReqAgentCover(resp1.req_agentcover);
                        setReqOurMarginInPaisa((resp1.req_ourmargin * 100).toFixed(0));
                        setReqSellRate(resp1.req_sellrate);
                        setReqIssuerCoverRate(resp1.req_issuercover);
                        setReqTotalMarginInRs((1 * resp1.req_sellrate - 1 * resp1.req_issuercover).toFixed(4));
                        setReqQuantity(resp1.req_quantity);

                        setReqAgentCommissionType(resp1.req_agent_commission_type);
                        setReqAgentCommssionFlat(resp1.req_agent_commission_flat);
                        setReqAgentCommssionPiasa(resp1.req_agent_commission_paisa);

                        setReqAgentCommssionBankCharges(resp1.req_commission_on_bank_charges);
                        setReqAgentCommssionNostroCharges(resp1.req_commission_on_nostro);

                        setLeadNo(resp1.req_enquiryno);
                        setLeadValue({ "id": resp1.leadNo, "label": resp1.enq_loanacctno + " " + resp1.enq_name });

                        if (resp1.agentid == '0') {
                            setPickedAgent(null);
                            setAgentAccount(0);
                            setAgentGroup(0);
                        } else {
                            handlePickedAgentChange({ id: resp1.agentid, label: resp1.agentlabel });
                        }

                        if (resp1.execid == "0") {
                            setPickedExecutive(null);
                        } else {
                            handlePickedExecutiveChange({ id: resp1.execid, label: resp1.execlabel });
                        }
                        //console.log("lead no : " + resp1.req_enquiryno);
                        //console.log("lead value :" + '{ "id": resp1.leadNo, "label": resp1.enq_loanacctno + " " + resp1.enq_name }');

                        setReqTotalReceivable(
                            ((resp1.req_sellrate * resp1.req_quantity).toFixed(2) * 1 + resp1.req_tcs * 1 + resp1.req_gst * 1 + resp1.req_bankcharges * 1 + resp1.req_nostrocharges * 1 + resp1.req_roundoff * 1).toFixed()
                        );
                        setPayListData(resp1.req_paymentdetail);
                        let tvalue = 0;
                        if (resp1.req_paymentdetail.length > 0) {
                            let arr = resp1.req_paymentdetail;
                            for (var i = 0; i < arr.length; ++i) {
                                tvalue = tvalue * 1 + arr[i]["amnt"] * 1;
                            }
                            setReqTotalReceived(tvalue);
                        }
                        setReqPayBankAmnt((resp1.req_sellrate * resp1.req_quantity).toFixed(2) * 1 + resp1.req_tcs * 1 + resp1.req_gst * 1 + resp1.req_bankcharges * 1 + resp1.req_nostrocharges * 1 + 1 * resp1.req_roundoff - tvalue);
                        setDocListData(resp1.req_documentdetail);

                        Common.callApi(Common.apiAddDetails, [sid, 'kycdoclist', resp1.req_purpose], function (result4) {
                            let resp4 = JSON.parse(result4);
                            setDdReqDocOptions(resp4);
                        });

                        Common.callApi(Common.apiCountry, [sid, 'ddlistjson'], function (result2) {
                            setDdReqCorresBankCountryOptions(JSON.parse(result2));
                            setDdReqBenCountryOptions(JSON.parse(result2));
                        });
                        Common.callApi(Common.apiBank, [sid, 'ddlistjsonbranchwise', resp1.req_brnno], function (result3) {
                            setDdReqPayBankOptions(JSON.parse(result3));
                        });
                        Common.callApi(Common.apiProductType, [sid, 'ddlistjson'], function (result) {
                            setDdReqProductTypeOptions(JSON.parse(result));
                        });
                        Common.callApi(Common.apiPurpose, [sid, 'ddlistjsontt'], function (result) {
                            setDdReqPurposeOptions(JSON.parse(result));
                        });
                        Common.callApi(Common.apiPurpose, [sid, 'ddlistjsonttallsub', resp1.req_purpose], function (result) {
                            setDdReqSubPurposeOptions(JSON.parse(result));
                        });
                        setReqAgentLocation(resp1.req_agentlocation);


                        Common.callApi(Common.apiCommissionChangeAllowed, [sid, 'check', JSON.stringify({ reqAgent: resp1.req_agentno, reqBranch: resp1.req_brnno })], function (result) {
                            setAgentCommissionOpenBlockedFlag(JSON.parse(result).msg);
                            // console.log("first check open blocked : Agent : " + resp1.req_agentno + " Branch : " + resp1.req_brnno + " result : " + result);
                        });


                    });


                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function isAddDetailsFinal() {
        return !(reqAddDetailsFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1));
    }

    function isAddPaymentFinal() {
        return !(reqAddPaymentFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1));
    }

    function isAddDocumentFinal() {
        return !(reqDocumentsFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1));
    }

    function btnBackClick() {
        setEntityType(entityType);  // just to remove warning in build. no require code.
        props.callInProgress();
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnDraftClick() {
        saveAddDetails("D");
    }

    function btnFinalClick() {
        if (reqRemitterName === "" || reqRemitterAddress === "" || reqRemitterCity === ""
            || reqRemitterIdType === "" || reqRemitterIdType === "0" || reqRemitterIdNo === ""
            || reqBeneAdd === "" || reqBenCountry === "" || reqBenCity === ""
            || ((reqBeneBank === "" || reqBeneBankAdd === "" || reqBeneBankAcct === "" || reqBeneBankCountry === "" || reqBeneBankCountry === "0") && reqData.req_productcode === "TT")
            || reqPurpose === "0"
            || (reqBeneRoutingNo === "" && reqData.req_isd === "USD" && reqBenCountry === 2 && reqData.req_productcode === "TT")
            || (reqBeneSortCode === "" && reqData.req_isd === "GBP" && reqBenCountry === 3 && reqData.req_productcode === "TT")
            || (reqBeneBsbNo === "" && reqData.req_isd === "AUD" && reqBenCountry === 5 && reqData.req_productcode === "TT")
            || (reqBeneTransitNo === "" && reqData.req_isd === "CAD" && reqBenCountry === 9 && reqData.req_productcode === "TT")
            || (reqPurpose === "13" && reqSubPurpose === "0")
            || (
                (reqLoanAccountNo.trim() === "" || reqLoanApplicant.trim() === "" || reqLoanApplicantPassport.trim() === ""
                    || reqLoanApplicantPan.trim() === "" || reqLoanCoApplicant.trim() === "" || reqLoanCoApplicantPan.trim() === "")
                && (reqAgent * 1 === 13 || reqAgent * 1 === 14)
            )
            || (reqAgent * 1 === 14 && reqLoanAccountNo.trim() === "")
            || (reqAgent * 1 === 16 && reqLoanAccountNo.trim() === "")
            || (reqAgent === "15" && reqAgentLocation === "0")
            || ((reqAgent * 1 === 13 || reqAgent * 1 === 14) && reqAgentCover * 1 === 0)
            || (reqCorresBankAcctNo.trim() !== "" && reqCorresBankCountry * 1 <= 1)
        ) {

            var msg = [], i = 0;
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqPurpose === "0" ? " Purpose " : '');
            msg[i++] = (reqRemitterName === "" ? " Remitter Name " : '');
            msg[i++] = (reqRemitterAddress === "" ? " Remitter Address " : '');
            msg[i++] = (reqRemitterCity === "" ? " Remitter City " : '');
            msg[i++] = ((reqRemitterIdType === "" || reqRemitterIdType === "0") ? " Remitter Id Type " : '');
            msg[i++] = (reqRemitterIdNo === "" ? " Remitter Id Number " : '');
            msg[i++] = (reqBeneAdd === "" ? " Beneficiary Address " : '');
            msg[i++] = (reqBenCountry === "" ? " Beneficiary Country " : '');
            msg[i++] = (reqBenCity === "" ? " Beneficiary City " : '');
            msg[i++] = (reqData.req_productcode === "TT" && reqBeneBank === "" ? " Beneficiary Bank " : '');
            msg[i++] = (reqData.req_productcode === "TT" && reqBeneBankAdd === "" ? " Beneficiary Bank Address " : '');
            msg[i++] = (reqData.req_productcode === "TT" && (reqBeneBankCountry === "" || reqBeneBankCountry === "0") ? " Beneficiary Bank Country " : '');
            // msg[i++] = (reqBeneSwiftCode === "" ? " Beneficiary Swift Code " : '');
            msg[i++] = (reqData.req_productcode === "TT" && reqBeneBankAcct === "" ? " Beneficiary Bank Account " : '');
            msg[i++] = (reqData.req_productcode === "TT" && (reqBeneRoutingNo === "" && reqData.req_isd === "USD" && reqBenCountry === 2) ? " Routing Number " : '');
            msg[i++] = (reqData.req_productcode === "TT" && (reqBeneSortCode === "" && reqData.req_isd === "GBP" && reqBenCountry === 3) ? " Sort Code " : '');
            msg[i++] = (reqData.req_productcode === "TT" && (reqBeneBsbNo === "" && reqData.req_isd === "AUD" && reqBenCountry === 5) ? " BSB Number " : '');
            msg[i++] = (reqData.req_productcode === "TT" && (reqBeneTransitNo === "" && reqData.req_isd === "CAD" && reqBenCountry === 9) ? " Transit Number " : '');
            msg[i++] = (reqPurpose === "13" && reqSubPurpose === "0" ? " Sub Purpose Code " : '');

            if (reqAgent * 1 === 13 || reqAgent * 1 === 14 || reqAgent * 1 === 16) {
                msg[i++] = (reqLoanAccountNo.trim() === "" ? " Loan Account " : '');

            }
            if (reqAgent * 1 === 13 || reqAgent * 1 === 14) {
                // msg[i++] = (reqAgent * 1 === "14" && reqLoanAccountNo.trim() === "" ? " Loan Account " : '');
                msg[i++] = (reqLoanApplicant.trim() === "" ? " Loan Applicant " : '');
                msg[i++] = (reqLoanApplicantPassport.trim() === "" ? " Loan Applicant Passport" : '');
                msg[i++] = (reqLoanApplicantPan.trim() === "" ? " Loan Applicant PAN" : '');
                msg[i++] = (reqLoanCoApplicant.trim() === "" ? " Loan Co Applicant" : '');
                msg[i++] = (reqLoanCoApplicantPan.trim() === "" ? " Loan Co Applicant PAN" : '');
            }
            msg[i++] = ((reqAgent * 1 === 13 || reqAgent * 1 === 14) && reqAgentCover * 1 === 0 ? " Agent Cover Rate" : '');
            msg[i++] = (reqAgent === "15" && reqAgentLocation === "0" ? " Agent Location" : '');
            msg[i++] = ((reqCorresBankAcctNo.trim() !== "" && reqCorresBankCountry * 1 <= 1) ? "Correspondent bank Country" : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        /*  else if (reqRemitterDob >= (new Date())) {
                setMsgText(Common.getMessage("MSG0007"));
                setMsgBox(true);
            }
        */
        else {
            if (reqTotalReceivable * 1 <= reqTotalReceived * 1) {
                setShowConfirmBox(true);
                /*if (window.confirm('Are you sure to lock the Additional Details ? Locked Additional Details can not be modified.')) {
                    saveAddDetails("F");
                } else {
                    saveAddDetails("D");
                }*/
            } else {
                setMsgText(Common.getMessage("MSG0008"));
                setMsgBox(true);
            }
        }
    }
    function saveAddDetails(saveMode) {
        setShowConfirmBox(false);
        $('.loader').show();
        var object1 = {
            srno: reqData.req_srno,
            saveMode: saveMode,
            reqProductType: reqProductType,
            reqPurpose: reqPurpose,
            reqSubPurpose: reqSubPurpose,
            reqRemitterType: reqRemitterType,
            reqRemitterName: reqRemitterName,
            reqRemitterDob: Common.dateYMD(reqRemitterDob),
            reqRemitterAddress: reqRemitterAddress,
            reqRemitterIdType: reqRemitterIdType,
            reqRemitterIdNo: reqRemitterIdNo,
            reqRemitterOccupation: reqRemitterOccupation,
            reqRemitterAnnualIncome: reqRemitterAnnualIncome,
            reqRemitterCity: reqRemitterCity,
            reqBenCountry: reqBenCountry,
            reqBenCity: reqBenCity,
            reqBeneBank: reqBeneBank,
            reqBeneBankAcct: reqBeneBankAcct,
            reqBeneBankAdd: reqBeneBankAdd,
            reqBeneBankCountry: reqBeneBankCountry,
            reqBeneSwiftCode: reqBeneSwiftCode,
            reqBeneIbanNo: reqBeneIbanNo,
            reqBeneRoutingNo: reqBeneRoutingNo,
            reqBeneSortCode: reqBeneSortCode,
            reqBeneBsbNo: reqBeneBsbNo,
            reqBeneTransitNo: reqBeneTransitNo,
            reqBeneType: reqBeneType,
            reqBeneName: reqBeneName,
            reqBeneAdd: reqBeneAdd,
            reqStudentDetail: reqStudentDetail,
            reqOtherDetail: reqOtherDetail,
            reqCorresBankName: reqCorresBankName,
            reqCorresBankAcctNo: reqCorresBankAcctNo,
            reqCorresBankCountry: reqCorresBankCountry,
            reqCorresBankAdd: reqCorresBankAdd,
            reqDocVerify: reqDocVerify,
            reqPayDetail: payListData,
            reqReference: reqReference,
            reqAgent: reqAgent,
            reqLoanAccountNo: reqLoanAccountNo,
            reqLoanApplicant: reqLoanApplicant,
            reqLoanApplicantPassport: reqLoanApplicantPassport,
            reqLoanApplicantPan: reqLoanApplicantPan,
            reqLoanCoApplicant: reqLoanCoApplicant,
            reqLoanCoApplicantPassport: reqLoanCoApplicantPassport,
            reqLoanCoApplicantPan: reqLoanCoApplicantPan,
            reqAgentLocation: reqAgentLocation,
            reqPan: reqPan,
            reqNameOnPan: reqNameOnPan,
            reqPanFatherName: reqPanFatherName,
            agentAccount: agentAccount,
            agentGroup: agentGroup,
            pickedExecutive: pickedExecutive,
            leadNo: leadNo,
            reqAgentCover: reqAgentCover,
            reqAgentCommissionType: reqAgentCommissionType,
            reqAgentCommssionPiasa: reqAgentCommssionPiasa,
            reqAgentCommssionFlat: reqAgentCommssionFlat,
            reqAgentCommssionBankCharges: reqAgentCommssionBankCharges,
            reqAgentCommssionNostroCharges: reqAgentCommssionNostroCharges,
            reqIsd: reqData.req_isd,
            reqBranch: reqBranch,
            reqIssuerBankCode: reqData.req_bank,
            reqQuantity: reqData.req_quantity
        }
        Common.callApi(Common.apiAddDetails, [sid, 'save', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                if (saveMode === "F") {
                    setReqAddDetailsFinal(1);
                    setReqAddPaymentFinal(1);
                    setReqDocumentsFinal(1);
                }

            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });

        setRefreshCounter(refreshCounter + 1);
    }

    function handleReqPayBank(v, t) {
        setReqBankCode(v);
        setReqBankName(t);
    }

    function btnAddPayment() {
        if (reqPayBankCode === "0" || reqPayBankRefNo === "" || reqPayBankAmnt === "" || reqPayBankAmnt * 1 <= 0) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else if (reqPayBankCode === "49" && payListData.some((item) => item.bank * 1 === 49)) {
            setMsgText("Only one Cash entry is allowed.");
            setMsgBox(true);
        } else if (reqPayBankCode === "49" && reqPayBankAmnt * 1 > 49999) {
            setMsgText("CASH cannot be more than 49999.");
            setMsgBox(true);
        } else {
            setPayListData(Common.arrayAddItem(payListData, {
                "srno": Common.getRandomString(),
                "bank": reqPayBankCode,
                "banknm": reqPayBankName,
                "amnt": reqPayBankAmnt,
                "refno": reqPayBankRefNo,
                "paygateway": 0,
                "paydate": Common.dateYMD(reqPayBankDate)
            }));
            setReqBankCode(0);
            setReqPayBankRefNo("");
            // setReqPayBankAmnt("");
            if ((reqTotalReceivable * 1 - reqTotalReceived * 1 - reqPayBankAmnt * 1) > 0) {
                setReqPayBankAmnt(reqTotalReceivable * 1 - reqTotalReceived * 1 - reqPayBankAmnt * 1);
            }
            setReqTotalReceived(reqTotalReceived * 1 + reqPayBankAmnt * 1);
            setRefreshCounter(refreshCounter + 1);
        }
    }

    function btnDeletePaymentClick(srno, amnt) {
        setPayListData(Common.arrayRemoveItem(payListData, "srno", srno));
        if ((reqTotalReceivable * 1 - reqTotalReceived * 1 + amnt * 1) > 0) {
            setReqPayBankAmnt(reqTotalReceivable * 1 - reqTotalReceived * 1 + amnt * 1);
        }
        setReqTotalReceived(reqTotalReceived * 1 - amnt * 1);
        setRefreshCounter(refreshCounter + 1);
    }

    // reqDocId * 1 === 23 
    function btnUploadFile() {
        $('.loader').show();
        if (reqDocId * 1 === 23) {
            btnUploadFileHarddisk();
        } else {
            awsUploadFile();
        }
    }

    function btnUploadFileHarddisk() {
        $('.loader').show();

        if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');
            if (reqDocId === "0") {
                $('.loader').hide();
                setMsgText("Please fill document name.");
                setMsgBox(true);
            } else if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {

            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'KYC',
                    srno: reqData?.req_srno,
                    pageright: 'ADDDETAILS',
                    docid: reqDocId,
                    remark: reqDocRemark,
                    reqCoverBank: reqCoverBank,
                    reqIsd: reqData?.req_isd
                }

                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    let resp = JSON.parse(result);
                    $('.loader').hide();
                    if (resp.error === "") {
                        setDocListData(resp.docdetail);
                        alert(resp.message);
                        setReqDocId("0");
                        setReqDocRemark("");
                    } else if (resp.error) {
                        alert(resp.error);
                    } else {
                        //alert(Common?.resp?.status);
                    }
                });
            }
        }
    }

    useEffect(() => {
        setPaxList(reqDocId)
    }, [reqDocId])

    async function awsUploadFile() {
        $('.loader').show();
        if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');
            var selectedFile = document.getElementById('fileToUpload').files[0]
            if (reqDocId === "0") {
                $('.loader').hide();
                setMsgText("Please fill document name.");
                setMsgBox(true);
            } else if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {

            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else if (props.srno == "" || reqDocId == '0' || reqDocId == '') {
                $('.loader').hide();
                setMsgText("Something went wrong. Please refresh the page and try again.");
                setMsgBox(true);
            } else if (reqDocRemark == "") {
                $('.loader').hide();
                setMsgText("Remark required.");
                setMsgBox(true);
            } else {
                let zenRefNo = props.srno
                const obj = {
                    sid: sid,
                    pageright: "ADDDETAILS",
                    uploadType: "KYC",
                    filename: tempArray[1],
                    location: reqBranch,
                    type: 'TT',
                    srno: zenRefNo,
                    docno: reqDocId,
                    remark: reqDocRemark,
                    key: `zeneremit/${reqBranch}-TT-${zenRefNo}-${reqDocId}-${Common.getYmdHis()}-${Common.getRandomString(10)}.${tempArray[1]}`,
                }
                Common.callApi(Common.apiAWS, [sid, "getUploadUrl", JSON.stringify(obj)], async (result) => {
                    let res = JSON.parse(result)
                    const url = res.url;
                    // const docdetail = res.data;
                    // setDocListData(docdetail);
                    setReqDocId("0");
                    setReqDocRemark("");
                    const resp = await Common.uploadFiletoAWSbucket(url, selectedFile,sid);
                    // getUploadedDoc(`transaction/${reqBranch}-TT-${zenRefNo}`); 
                    setNFile("");
                    console.log("aws response ",resp);
                    if (resp.ok && resp.status === 200) {
                        Common.callApi(Common.apiAWS, [sid, "insertData", JSON.stringify(obj)], async (result) => {
                            $('.loader').hide();
                            let respon = JSON.parse(result)
                            const docdetail = respon.data;
                            setDocListData(docdetail);
                            if (respon.status) {
                                setMsgText("Uploaded Successfully ✅");
                                setMsgBox(true);
                            } else {
                                setMsgText("Upload Failed ❌");
                                setMsgBox(true);
                            }
                        });
                    } else {
                        setMsgText("Upload Failed ❌");
                        setMsgBox(true);
                    }
                });
            }
        }
    }


    function btnDeleteDocumentClick(srno, docid, filename, type) {
        var object1 = {
            srno: srno,
            filename: filename,
            docid: docid
        }


        if (type == 1) {

            let zenRefNo = props.srno

            let obj = {
                key: filename,
                location: reqBranch,
                type: 'TT',
                srno: srno,
                docno: docid,
            };
            Common.callApi(Common.apiAWS, [sid, "deleteData", JSON.stringify(obj)], async (result) => {
                // getUploadedDoc(`transaction/${reqBranch}-${hdrType}-${srno}`);

            });

        }


        Common.callApi(Common.apiInProgress, [sid, 'docremove', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.error === "") {
                setDocListData(resp.docdetail);
                setMsgText("Deleted Successfully.");
                setMsgBox(true);
            } else {
                alert(resp.error);
            }

        });
    }

    function btnDocumentView(srno, filename) {
        $('.loader').show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {

        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnFetchZenEremitTrn() {
        if (zenRefNo === "") {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            $('.loader').show();
            Common.callApi(Common.apiInProgress, [sid, 'detail', Common.getSrNoFromRefNo(zenRefNo)], function (result1) {
                let resp1 = JSON.parse(result1);
                setZenRefData(resp1);
                $('.loader').hide();
                if (resp1.req_srno * 1 > 0) {
                    setShowFetchZenEremit(true);
                } else {
                    setMsgText("Transaction not found.");
                    setMsgBox(true);
                }
            });
        }
    }

    function autoFillFormZen() {
        setReqRemitterAddress(zenRefData.req_remitteraddress);
        setReqRemitterCity(zenRefData.req_remittercity);
        setReqRemitterIdType(zenRefData.req_remitteridtype);
        setReqRemitterIdNo(zenRefData.req_remitteridno);
        setReqBeneType(zenRefData.req_benetype);
        setReqBeneName(zenRefData.req_benename);
        setReqBeneAdd(zenRefData.req_beneadd);
        setReqBenCountry(zenRefData.req_benecountry);
        setReqBenCity(zenRefData.req_benecity);
        setReqBeneSwiftCode(zenRefData.req_beneswiftcode);
        setReqBeneBank(zenRefData.req_benebank);
        setReqBeneBankAcct(zenRefData.req_benebankacct);
        setReqBeneBankAdd(zenRefData.req_benebankadd);
        setReqBeneBankCountry(zenRefData.req_benebankcountrycode)
        setReqOtherDetail(zenRefData.req_otherdetail);
        setReqBeneRoutingNo(zenRefData.req_beneroutingno);
        setReqBeneSortCode(zenRefData.req_benesortcode);
        setReqBeneBsbNo(zenRefData.req_benebsbno);
        setReqBeneTransitNo(zenRefData.req_benetransitno);
        setReqCorresBankName(zenRefData.req_corresbankname);
        setReqCorresBankAcctNo(zenRefData.req_corresbankacctno);
        setReqCorresBankAdd(zenRefData.req_corresbankadd);

        setShowFetchZenEremit(false);
        setMsgText("Form Updated");
        setMsgBox(true);
    }

    function btnFetchBackoffice() {
        if (fxTranNo === "") {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            $('.loader').show();
            var object1 = {
                srno: reqData.req_srno,
                backsrno: fxTranNo
            }
            Common.callApi(Common.apiBackoffice, [sid, 'fetch', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.recordfound === 1) {
                    setBackOfficeData(resp[0]);
                    setOrderDate(resp[0].orderDate);
                    setShowFetchTransaction(true);
                } else {
                    setMsgText("Transaction not found.");
                    setMsgBox(true);
                }
            });
        }
    }

    function autoFillForm() {

        if (reqData.req_isd === backOfficeData.isd
            && reqData.req_quantity === backOfficeData.isdQty) {
            setReqRemitterIdType(backOfficeData.idCode);
            setReqRemitterIdNo(Common.removeSpecialChar(backOfficeData.idSrNo));
            setReqBeneName(Common.removeSpecialChar(backOfficeData.beniName));
            // setReqBeneAdd(backOfficeData.add1 + " " + backOfficeData.add2 + " " + backOfficeData.add3);
            setReqBeneSwiftCode(Common.removeSpecialChar(backOfficeData.swiftCode));
            setReqBeneBank(Common.removeSpecialChar(backOfficeData.beniBank));
            setReqBeneBankAcct(Common.removeSpecialChar(backOfficeData.beniAcctNo));
            setReqBenCountry(backOfficeData.trvCountry);
            setReqBeneBankAdd(Common.removeSpecialChar(backOfficeData.add1 + " " + backOfficeData.add2 + " " + backOfficeData.add3));
            setReqPurpose(backOfficeData.purCode);
            setReqCorresBankAcctNo(backOfficeData.corresSwiftCd);
            setReqCorresBankAdd(backOfficeData.corresBankAdd);
            setReqCorresBankName(backOfficeData.corresBank);
            setReqOtherDetail(backOfficeData.remark1 + backOfficeData.remark2 + backOfficeData.remark3);

            /*
                    , beneficiaryType,ibanNum,nostroType,flywireRefNo,gicId,wubsRefNum
                    , applicationNum,corresBank,corresBankAdd,corresSwiftCd,remark1,remark2,remark3
            */

            //            setReqOtherDetail();
            setShowFetchTransaction(false);
            var object1 = {
                reqSrno: reqData.req_srno,
                fxTranNo: fxTranNo
            }
            Common.callApi(Common.apiAddDetails, [sid, 'updatefetchbackoffice', JSON.stringify(object1)], function (result) {
            });
            setMsgText("Form Updated");
            setMsgBox(true);
        } else {
            alert('Can Not Update. ISD or Quantity not matched.');
        }
    }

    function onChangePurpose(v) {
        setReqPurpose(v);
        setReqSubPurpose("0")
        setDdReqDocOptions([]);
        refreshClick();
        Common.callApi(Common.apiAddDetails, [sid, 'kycdoclist', v], function (result4) {
            let resp4 = JSON.parse(result4);
            setDdReqDocOptions(resp4);
            setRefreshCounter(refreshCounter + 1);
            refreshClick();
        });
        Common.callApi(Common.apiPurpose, [sid, 'ddlistjsonttallsub', v], function (result) {
            setDdReqSubPurposeOptions(JSON.parse(result));
        });

    }

    function refreshClick() {
        $('#btnRefresh').show();
        $('#btnRefresh').click();
        $('#btnRefresh').hide();
    }


    function btnUnlockCharges() {
        var object1 = {
            srno: reqData.req_srno
        }
        Common.callApi(Common.apiAddDetails, [sid, 'unlockcharges', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                btnBackClick();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function onChangeRefrence(id) {
        if (id === "S") {
            setReqAgent("0");
            setReqAgentLocation("0");
            setLeadNo("0");
            setLeadValue(null);
            setPickedAgent(null);
            setAgentAccount(0);
            setAgentGroup(0);
        }
        setReqReference(id);
        if (id === "A") {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        } else {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagent', 0], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        }
    }

    function onChangeAgent(id) {
        setReqAgent(id);
        setReqAgentCommissionType("F");
        setReqAgentLocation("0");
        setLeadNo("0");
        setLeadValue(null);
        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentlocation', 'A', id], function (result) {
            setDdReqAgentLocationOptions(JSON.parse(result));
        });
    }

    function downloadPaxList(reqCoverBank) {
        var object1 = {
            srno: 23,
            reqCoverBank: reqCoverBank
        }
        Common.callDownloadApiPost(Common.apiFormat, "post", [sid, 'paxlist', JSON.stringify(object1)]);
    }

    function handleLeadValue(value) {
        setLeadValue(value);
        const l = value.id.split('^');
        const enq_srno = l[1];
        setLeadNo(enq_srno);
    }

    const handlePickedAgentChange = (value) => {
        setPickedAgent(value);
        setReqAgentCommissionType("F");
        let a = value.id.split("^");
        setReqAgent(a[1]);
        setAgentGroup(a[2]);
        setAgentAccount(a[3]);
        setReqAgentLocation("0");
        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentlocation', 'A', a[1]], function (result) {
            setDdReqAgentLocationOptions(JSON.parse(result));
        });
        if (reqBranch !== "0") {
            Common.callApi(Common.apiCommissionChangeAllowed, [sid, 'check', JSON.stringify({ reqAgent: a[1], reqBranch: reqBranch })], function (result) {
                setAgentCommissionOpenBlockedFlag(JSON.parse(result).msg);
                //console.log("second check open blocked : Agent : " + value + " Branch : " + reqBranch + " result : " + result);
            });
        }

    }

    const handlePickedExecutiveChange = (value) => {
        setPickedExecutive(value);
    }

    const handleOurMargin = (valueInPaisa) => {

        var totalMarginInPaisa = ((1 * (reqData.req_sellrate) - 1 * (reqData.req_issuercover)) * 100).toFixed(2);

        if (1 * valueInPaisa <= 1 * totalMarginInPaisa) {
            var valueInRs = (valueInPaisa === '' ? 0 : (1 * valueInPaisa / 100).toFixed(4)); // 
            setReqAgentCover((1 * (reqData.req_issuercover) * 1 + 1 * valueInRs * 1).toFixed(4)); // 
            setReqOurMarginInPaisa(valueInPaisa);
        }
    }

    const handleAgentFlatCommission = (rsFlat) => {
        setReqAgentFlatCommission(rsFlat);

        var totalMarginInPaisa = (((1 * (reqData.req_sellrate) - 1 * (reqData.req_issuercover)) * 10000) / 100).toFixed(2);

        handleOurMargin(totalMarginInPaisa - Math.round(1000 * rsFlat / reqData.req_quantity) / 1000);
        // handleOurMargin(Math.round(1000 * rsFlat / reqData.req_quantity) / 1000);
    }
    ///////////////////////////////////////////////////////////////////////
    const onChangeAgentCommissionType = (v) => {
        setReqAgentCommissionType(v);

    }
    const handleAgentCommssionPiasa = (v) => {
        if (v === "") {
            v = 1 * 0;
        }
        if (1 * v < (100 * reqTotalMarginInRs)) {
            console.log("in");
            setReqAgentCommssionPiasa(v);
            setReqAgentCommssionFlat((v * reqQuantity / 100).toFixed(2));
            var agent_cover_rate = (reqData.req_sellrate - v / 100).toFixed(4);
            setReqAgentCover(agent_cover_rate);
            setReqOurMarginInPaisa(((1 * agent_cover_rate - 1 * reqIssuerCoverRate) * 100).toFixed(2));
        } else {
            console.log("out");
        }
    }
    const handleAgentCommssionFlat = (v) => {
        v = 1 * v;
        setReqAgentCommssionFlat(v);
        var agent_commission_in_paisa = ((v / (1 * reqQuantity)) * 100).toFixed(4);
        setReqAgentCommssionPiasa(agent_commission_in_paisa);
        var agent_cover_rate = (reqData.req_sellrate - (agent_commission_in_paisa / 100)).toFixed(4);
        setReqAgentCover(agent_cover_rate);
        setReqOurMarginInPaisa((((1 * agent_cover_rate) - (1 * reqIssuerCoverRate)) * 100).toFixed(2));
    }

    ///////////////////////////////////////////////

    const btnOrderRepClick = () => {
        const obj = {
            srno: props.srno,
        }
        Common.callApi(Common.apiAddDetails, [sid, 'getOrderReport', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            console.log("Response is :", resp.orderRep);
            console.log("Response of Individual is :", resp.orderRepInd);
            setOrderRepData(resp.orderRep);
            setOrderRepIndData(resp.orderRepInd);
            // Store data in local storage
            localStorage.setItem("orderRepData", JSON.stringify(resp.orderRep));
            localStorage.setItem("orderRepIndData", JSON.stringify(resp.orderRepInd));
            localStorage.setItem("amountInWords", resp.amountInWords);

            // Open new tab
            window.open("/report", "_blank");

        });
    }

    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };

    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <Button id="btnRefresh" style={{ "display": "none" }} variant="outline-success" size="sm" >Refresh</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h1>In Progress/Additional Details</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <RequestHeader rhdata={reqData}></RequestHeader>
                        </Col>
                    </Row>
                    {
                        (!Common.showPickList && (!isAddDetailsFinal()) && entityType === "B") ?
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>FXPLUS Transaction No : </Form.Label>
                                        <Form.Control type="text" placeholder="Transaction No" maxLength={10} autoComplete="off"
                                            value={fxTranNo}
                                            onChange={(e) => Common.validateNumValue(e.target.value, setFxTranNo)}
                                            disabled={isAddDetailsFinal()}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnFetchBackoffice()} >Fetch</Button>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>ZenEremit Reference No : </Form.Label>
                                        <Form.Control type="text" placeholder="ZenEremit Reference No" maxLength={50} autoComplete="off"
                                            value={zenRefNo}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setZenRefNo)}
                                            disabled={isAddDetailsFinal()}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnFetchZenEremitTrn()} >Fetch</Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                            : null
                    }
                    {
                        Common.showPickList ? <>
                        </> : <>
                            <Row>
                                <Col className='divHide col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>Type<span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            disabled={isAddDetailsFinal()}
                                            value={reqProductType}
                                            onChange={(e) => setReqProductType(e.target.value)}  >
                                            {ddReqProductTypeOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {
                                    Common.showPickList &&
                                    <Col className="col-md-3 col-6">
                                        <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={pickedExecutive}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchExecutivePicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handlePickedExecutiveChange}
                                            isDisabled={entityType === 'A' || isAddDetailsFinal()}
                                        >
                                        </AsyncSelect>
                                    </Col>
                                }
                                <Col className='col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>Purpose <span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            disabled={isAddDetailsFinal()}
                                            value={reqPurpose}
                                            onChange={(e) => onChangePurpose(e.target.value)}  >
                                            <input type="text" />
                                            {ddReqPurposeOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {
                                    reqPurpose === "13" ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group >
                                                    <Form.Label>Sub Purpose <span className="mandatory">*</span></Form.Label>
                                                    <Form.Select
                                                        disabled={isAddDetailsFinal()}
                                                        value={reqSubPurpose}
                                                        onChange={(e) => setReqSubPurpose(e.target.value)}  >
                                                        <input type="text" />
                                                        {ddReqSubPurposeOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </> :
                                        <>
                                            <Col>&nbsp;</Col>
                                        </>
                                }
                            </Row>

                        </>
                    }


                    {
                        entityType === "B" ?
                            <>
                                <Row>


                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Reference<span className="mandatory">*</span>Self/Agent</Form.Label>
                                            <Form.Select
                                                value={reqReference}
                                                onChange={(e) => onChangeRefrence(e.target.value)}
                                                disabled={entityType === 'A' || isAddDetailsFinal()} >
                                                <option value="S">Self</option>
                                                <option value="A">Agent</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {
                                        reqReference === "A" ? <>
                                            {
                                                Common.showPickList ?
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pickedAgent}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchEremitAgentPickList(search, reqBranch)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handlePickedAgentChange}
                                                                isDisabled={entityType === 'A' || isAddDetailsFinal()}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    :
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                                            <Form.Select
                                                                value={reqAgent}
                                                                onChange={(e) => onChangeAgent(e.target.value)}
                                                                disabled={entityType === 'A' || isAddDetailsFinal()} >
                                                                {ddReqAgentOptions.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                            }
                                            {
                                                reqAgent * 1 > 0 ? <>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Agent Location</Form.Label>
                                                            <Form.Select
                                                                value={reqAgentLocation}
                                                                onChange={(e) => setReqAgentLocation(e.target.value)}
                                                                disabled={entityType === 'A' || isAddDetailsFinal()} >
                                                                {ddReqAgentLocationOptions.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </> : null
                                            }
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Lead</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={leadValue}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchLeadMandatory(search, reqBranch, reqAgent, reqAgentLocation)}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(e) => handleLeadValue(e)}
                                                        isDisabled={entityType === 'A' || isAddDetailsFinal()}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>

                                            {
                                                /*
                                                    <Col>
                                                        <Form.Group>
                                                        <Form.Label>Agent Cover Rate</Form.Label>
                                                        <Form.Control type="text" placeholder="Agent Cover Rate"
                                                            maxLength={10} autoComplete="off"
                                                            value={reqAgentCover}
                                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqAgentCover)}
                                                            disabled={(!(reqAgent === "13" || reqAgent === "14" || reqAgent === "16")) || entityType === 'A' || isAddDetailsFinal()}
                                                        />
                                                        </Form.Group>
                                                    </Col>
                                                */
                                            }


                                        </> : <>
                                            <Col>&nbsp;</Col>
                                            <Col>&nbsp;</Col>
                                            <Col>&nbsp;</Col>
                                        </>
                                    }

                                </Row>
                                {
                                    1 * reqAgent > 0 ? <>
                                        <Row>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>Commission Type</Form.Label>
                                                    <Form.Select
                                                        value={reqAgentCommissionType}
                                                        onChange={(e) => onChangeAgentCommissionType(e.target.value)}
                                                        disabled={(reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal() || (reqAgentCommissionType === "F" && sessionStorage.disableCommissionChange == "1")}
                                                    >
                                                        <option value="P">Paisa</option>
                                                        <option value="F">Flat</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Agent Commission in  Paisa</Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqAgentCommssionPiasa}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, handleAgentCommssionPiasa)}
                                                        disabled={(reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal() || reqAgentCommissionType === "F"}
                                                    />
                                                </Form.Group>

                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Agent Commission Flat</Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqAgentCommssionFlat}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, handleAgentCommssionFlat)}
                                                        disabled={agentCommissionOpenBlockedFlag === "BLOCKED" || entityType === 'A' || isAddDetailsFinal() || reqAgentCommissionType === "P"}
                                                    /*
                                                        disabled={((reqAgent === "13" && sessionStorage.entityId !== "0") || reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal() || reqAgentCommissionType === "P"}
                                                    */
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Agent Cover Rate</Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqAgentCover}
                                                        disabled={true}
                                                    />
                                                </Form.Group>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                Quantity : {reqQuantity}&nbsp;Sale Rate : {reqSellRate}&nbsp; Issuer Cover Rate : {reqIssuerCoverRate} &nbsp;
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                Total Margin in Paisa {reqTotalMarginInRs * 100}&nbsp;
                                                Our Margin in Paisa : {reqOurMarginInPaisa}&nbsp;

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                Our Margin in Rs : {((reqOurMarginInPaisa * reqQuantity) / 100).toFixed(2)}; &nbsp;
                                                Agent Margin in Rs: {((reqAgentCommssionPiasa * reqQuantity) / 100).toFixed(2)}; &nbsp;
                                            </Col>
                                        </Row>
                                    </> : null
                                }
                                <Row className='border-bottom'>
                                    <Col>&nbsp;</Col>
                                </Row>
                                {
                                    1 * reqAgent > 0 ? <>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Agent Flat Commission on Bank Charges</Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqAgentCommssionBankCharges}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqAgentCommssionBankCharges)}
                                                        disabled={(reqAgent === "13" || reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal()}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Agent Flat Commission on Nostro Charges</Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqAgentCommssionNostroCharges}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqAgentCommssionNostroCharges)}
                                                        disabled={(reqAgent === "13" || reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal()}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>&nbsp;</Col>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                    </> : null
                                }
                                {
                                    1 * reqAgent > 0 && 1 == 2 ? <>
                                        <Row>
                                            <Col>
                                                {/*
                                                "13"	"AVANSE FINANCIAL SERVICES LTD"
                                                "14"	"AUXILO FINSERVE PVT LTD"
                                                "16"	"INCRED"
                                            */}
                                                <Form.Group>
                                                    <Form.Label>Our Margin in Paisa</Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqOurMarginInPaisa}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, handleOurMargin)}
                                                        disabled={(reqAgent === "13" || reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal()}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>


                                                <Form.Group>
                                                    <Form.Label>Agent Commission Flat for reverse </Form.Label>
                                                    <Form.Control type="text" placeholder="Agent Cover Rate"
                                                        maxLength={10} autoComplete="off"
                                                        value={reqAgentFlatCommission}
                                                        onChange={(e) => Common.validateDecValue(e.target.value, handleAgentFlatCommission)}
                                                        disabled={(reqAgent === "13" || reqAgent === "14" || reqAgent === "16") || entityType === 'A' || isAddDetailsFinal()}
                                                    />
                                                </Form.Group>




                                            </Col>
                                            <Col>&nbsp;</Col>
                                            <Col>&nbsp;</Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                Sell Rate Rs.: {(reqData.req_sellrate)}&nbsp;
                                                Settle Rate Rs.: {(reqData.req_issuercover)}&nbsp;&nbsp;&nbsp;
                                                Agent Booking Rate Rs.: {(1 * reqAgentCover).toFixed(4)}&nbsp;
                                            </Col>
                                        </Row>

                                    </> : null
                                }


                            </> : null
                    }
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <h5>Loan Related Details</h5>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Account No {reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null} </Form.Label>
                                <Form.Control type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                    value={reqLoanAccountNo}
                                    onChange={(e) => setReqLoanAccountNo(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Applicant {reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Applicant" maxLength={50} autoComplete="off"
                                    value={reqLoanApplicant}
                                    onChange={(e) => setReqLoanApplicant(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Applicant Passport{reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Applicant Passport" maxLength={50} autoComplete="off"
                                    value={reqLoanApplicantPassport}
                                    onChange={(e) => setReqLoanApplicantPassport(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Applicant Pan{reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Applicant Pan" maxLength={50} autoComplete="off"
                                    value={reqLoanApplicantPan}
                                    onChange={(e) => setReqLoanApplicantPan(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Co Applicant{reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Co Applicant" maxLength={50} autoComplete="off"
                                    value={reqLoanCoApplicant}
                                    onChange={(e) => setReqLoanCoApplicant(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Co App Passport{reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Co App Passport" maxLength={50} autoComplete="off"
                                    value={reqLoanCoApplicantPassport}
                                    onChange={(e) => setReqLoanCoApplicantPassport(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Loan Co App Pan{reqReference === "A" && reqAgent * 1 === 13 ? <span className="mandatory">*</span> : null}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Co App Pan" maxLength={50} autoComplete="off"
                                    value={reqLoanCoApplicantPan}
                                    onChange={(e) => setReqLoanCoApplicantPan(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Remitter Details</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Remitter Type<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqRemitterType}
                                    onChange={(e) => setReqRemitterType(e.target.value)}
                                    disabled={true}
                                >
                                    <option value="I">Individual</option>
                                    <option value="C">Entity</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Remitter Name<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Client Name" maxLength={50} autoComplete="off"
                                    value={reqRemitterName}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterName)}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>

                        <Col>
                            <Form.Group>
                                <Form.Label>Remitter Address<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Remitter Address" maxLength={reqData.req_isd === "EUR" ? 70 : 99} autoComplete="off"
                                    value={reqRemitterAddress}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterAddress)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Remitter City</Form.Label>
                                <Form.Control type="text" placeholder="Remitter City" maxLength={50} autoComplete='off'
                                    value={reqRemitterCity}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterCity)}
                                    disabled={isAddDetailsFinal()}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Remitter ID Type<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqRemitterIdType}
                                    onChange={(e) => setReqRemitterIdType(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                >
                                    <option value="0">Select</option>
                                    <option value="1">Passport</option>
                                    <option value="2">Election Card</option>
                                    <option value="3">Driving License</option>
                                    <option value="4">Ration Card</option>
                                    <option value="5">PAN</option>
                                    <option value="6">Other Govt. ID</option>
                                    <option value="7">Aadhaar Card</option>
                                    <option value="8">Aadhaar EID No</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Remitter ID Number<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="ID Number" maxLength={50} autoComplete="off"
                                    value={reqRemitterIdNo}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterIdNo)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row className='divHide'>
                        <Col>
                            <Form.Group >
                                <Form.Label>Date of Birth<span className="mandatory">*</span></Form.Label>
                                <DatePicker className="form-control"
                                    selected={reqRemitterDob}
                                    onChange={(date) => setReqRemitterDob(date)}
                                    isClearable={!isAddDetailsFinal()}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    disabled={isAddDetailsFinal()}
                                    customInput={
                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Occupation<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Occupation" maxLength={50} autoComplete="off"
                                    value={reqRemitterOccupation}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterOccupation)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Annual Income<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Annual Income" maxLength={10} autoComplete="off"
                                    value={reqRemitterAnnualIncome}
                                    onChange={(e) => Common.validateNumValue(e.target.value, setReqRemitterAnnualIncome)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>

                        <Col>&nbsp;</Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Beneficiary Details</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Beneficiary Type<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqBeneType}
                                    onChange={(e) => setReqBeneType(e.target.value)}
                                    disabled={isAddDetailsFinal()}
                                >
                                    <option value="I">Individual</option>
                                    <option value="C">Entity</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Beneficiary Name<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Beneficiary Name" maxLength={100} autoComplete="off"
                                    value={reqBeneName}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBeneName)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Beneficiary Address<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Beneficiary Address" maxLength={99} autoComplete="off"
                                    value={reqBeneAdd}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBeneAdd)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>Beneficiary Country<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqBenCountry}
                                    onChange={(e) => setReqBenCountry(e.target.value)}
                                    disabled={isAddDetailsFinal()} >
                                    {ddReqBenCountryOptions.map((res) =>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>Beneficiary City<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder='Beneficiary City' maxLength={50} autoComplete="off"
                                    value={reqBenCity}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBenCity)}
                                    disabled={isAddDetailsFinal()}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    {
                        reqData.req_productcode === "TT" ?
                            <>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Swift Code</Form.Label>
                                            <Form.Control type="text" placeholder="Swift Code" maxLength={20} autoComplete="off"
                                                value={reqBeneSwiftCode}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBeneSwiftCode)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Beneficiary Bank<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Beneficiary Bank" maxLength={100} autoComplete="off"
                                                value={reqBeneBank}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBeneBank)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Beneficiary Account No<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Beneficiary Account No" maxLength={50} autoComplete="off"
                                                value={reqBeneBankAcct}
                                                onChange={(e) => Common.validateAlpNumWSValue(e.target.value, setReqBeneBankAcct)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col >
                                        <Form.Group>
                                            <Form.Label>Beneficiary Bank Address<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Beneficiary Bank Address" maxLength={99} autoComplete="off"
                                                value={reqBeneBankAdd}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBeneBankAdd)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Beneficiary Bank Country<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqBeneBankCountry}
                                                onChange={(e) => setReqBeneBankCountry(e.target.value)}
                                                disabled={isAddDetailsFinal()} >
                                                {ddReqBenCountryOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>&nbsp;</Col>
                                    <Col>&nbsp;</Col>
                                    <Col>&nbsp;</Col>
                                </Row>
                            </> : null
                    }

                    <Row>
                        <Col >
                            <Form.Group>
                                <Form.Label>Additional Details</Form.Label>
                                <Form.Control type="text" placeholder="Other Details" maxLength={99} autoComplete="off"
                                    value={reqOtherDetail}
                                    onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqOtherDetail)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {
                        reqData.req_productcode === "TT" ?
                            <>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Routing No.(For USD)
                                                {
                                                    (reqData.req_isd === "USD" && reqBenCountry * 1 === 2) ?
                                                        <span className="mandatory">*</span>
                                                        : null
                                                }
                                            </Form.Label>
                                            <Form.Control type="text" placeholder="Routing No" maxLength={20} autoComplete="off"
                                                value={reqBeneRoutingNo}
                                                onChange={(e) => Common.validateAlpNumWSValue(e.target.value, setReqBeneRoutingNo)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col >
                                        <Form.Group>
                                            <Form.Label>Sort Code (For GBP)
                                                {
                                                    (reqData.req_isd === "GBP" && reqBenCountry * 1 === 3) ?
                                                        <span className="mandatory">*</span>
                                                        : null
                                                }
                                            </Form.Label>
                                            <Form.Control type="text" placeholder="Sort Code" maxLength={20} autoComplete="off"
                                                value={reqBeneSortCode}
                                                onChange={(e) => Common.validateAlpNumWSValue(e.target.value, setReqBeneSortCode)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col >
                                        <Form.Group>
                                            <Form.Label>BSB No.(For AUD)
                                                {
                                                    (reqData.req_isd === "AUD" && reqBenCountry * 1 === 5) ?
                                                        <span className="mandatory">*</span>
                                                        : null
                                                }
                                            </Form.Label>
                                            <Form.Control type="text" placeholder="BSB No" maxLength={20} autoComplete="off"
                                                value={reqBeneBsbNo}
                                                onChange={(e) => Common.validateAlpNumWSValue(e.target.value, setReqBeneBsbNo)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Transit No.(For CAD)
                                                {
                                                    (reqData.req_isd === "CAD" && reqBenCountry * 1 === 9) ?
                                                        <span className="mandatory">*</span>
                                                        : null
                                                }

                                            </Form.Label>
                                            <Form.Control type="text" placeholder="Transit No" maxLength={20} autoComplete="off"
                                                value={reqBeneTransitNo}
                                                onChange={(e) => Common.validateAlpNumWSValue(e.target.value, setReqBeneTransitNo)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </> : null
                    }

                    <Row >
                        {
                            reqData.req_purpose === "13" || reqData.req_purpose === "24" ?
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Student/University (not printed on swift)</Form.Label>
                                        <Form.Control type="text" placeholder="Student Details" maxLength={99} autoComplete="off"
                                            value={reqStudentDetail}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqStudentDetail)}
                                            disabled={isAddDetailsFinal()}
                                        />
                                    </Form.Group>
                                </Col>
                                : null
                        }
                        <Col className='divHide' >
                            <Form.Group>
                                <Form.Label>IBAN No.</Form.Label>
                                <Form.Control type="text" placeholder="IBAN No" maxLength={34} autoComplete="off"
                                    value={reqBeneIbanNo}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqBeneIbanNo)}
                                    disabled={isAddDetailsFinal()}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {
                        reqData.req_productcode === "TT" ?
                            <>
                                <Row className='border-bottom'>
                                    <Col>
                                        &nbsp;
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <h5>Correspondent Bank Details</h5>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Bank Name</Form.Label>
                                            <Form.Control type="text" placeholder="Bank Name" maxLength={50} autoComplete="off"
                                                value={reqCorresBankName}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqCorresBankName)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Swift Code</Form.Label>
                                            <Form.Control type="text" placeholder="Swift Code" maxLength={50} autoComplete="off"
                                                value={reqCorresBankAcctNo}
                                                onChange={(e) => Common.validateAlpNumWSValue(e.target.value, setReqCorresBankAcctNo)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col > {/*  className='divHide'  */}
                                        <Form.Group>
                                            <Form.Label>Bank Country<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqCorresBankCountry}
                                                onChange={(e) => setReqCorresBankCountry(e.target.value)}
                                                disabled={isAddDetailsFinal()}
                                            >
                                                {ddReqCorresBankCountryOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Bank Address</Form.Label>
                                            <Form.Control type="text" placeholder="Bank Address" maxLength={100} autoComplete="off"
                                                value={reqCorresBankAdd}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqCorresBankAdd)}
                                                disabled={isAddDetailsFinal()}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>&nbsp;</Col>
                                </Row>

                            </> : null
                    }
                    <Row className='border-bottom'>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Documents 1</h5>
                        </Col>
                    </Row>
                    {
                        entityType === "B" ?
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Document Verification</Form.Label>
                                        <Form.Select
                                            value={reqDocVerify}
                                            onChange={(e) => setReqDocVerify(e.target.value)}
                                            disabled={isAddDocumentFinal()}
                                        >
                                            <option value="U" >Upload</option>
                                            <option value="S" >Seen and Verify</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>&nbsp;</Col>
                                <Col>&nbsp;</Col>
                                <Col>&nbsp;</Col>
                            </Row>

                            : null

                    }
                    {
                        (reqPurpose === "14" || reqPurpose === "15" || reqPurpose === "19") ? <>
                            <Row>
                                <Col>
                                    <Badge bg="danger" >List of Travellers in excel is mandatory to upload for Tour Purpose.</Badge>
                                </Col>
                            </Row>
                        </> : null
                    }
                    {isAddDocumentFinal() ? null :
                        <>

                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>
                                            Document Name
                                            {
                                                reqDocId * 1 === 23 ? <>
                                                    <Badge className="handCursor" bg="primary" onClick={(e) => downloadPaxList(reqCoverBank)}>
                                                        Download Format
                                                    </Badge>
                                                </> : null
                                            }
                                        </Form.Label>
                                        <Form.Select
                                            value={reqDocId}
                                            onChange={(e) => setReqDocId(e.target.value)}
                                        >
                                            {ddReqDocOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Remark</Form.Label>
                                        <Form.Control type="text" value={reqDocRemark}
                                            onChange={(e) => setReqDocRemark(e.target.value)}
                                        ></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId='fileToUpload'>
                                        <Form.Label>File (Max 10MB)</Form.Label>
                                        <Form.Control type="file"></Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label>
                                        <br />
                                        <Button
                                            variant="outline-success"
                                            size="sm"
                                            onClick={btnUploadFile}
                                        >
                                            Upload
                                        </Button>
                                    </Form.Group>
                                </Col>

                            </Row>
                        </>
                    }
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                         <td>Upload Timestamp</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.doc_filename}>
                                            <td>
                                                {
                                                    reqDocumentsFinal * 1 === 0 && res.doc_approved * 1 === 0 ?
                                                        <>
                                                            <div className="colorThemeBlue">
                                                                <span className="handCursor" onClick={(e) => btnDeleteDocumentClick(res.doc_srno, res.doc_id, res.doc_aws == 1 ? res.doc_aws_path : res.doc_filename, res.doc_aws)}>
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </span>
                                                            </div>
                                                        </>
                                                        : null
                                                }
                                            </td>
                                            <td className='divHide'>{res.doc_srno}</td>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>
                                            <td>{res.doc_uploadedat}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    {
                                                        (res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                            || res.doc_ext === "jpg" || res.doc_ext === "png")) ? <>
                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>&nbsp;
                                                        </> : null
                                                    }
                                                    &nbsp;
                                                    {(res.doc_aws == 1 &&
                                                        (
                                                            res.doc_ext === "pdf" ||
                                                            res.doc_ext === "jpeg" ||
                                                            res.doc_ext === "gif" ||
                                                            res.doc_ext === "jpg" ||
                                                            res.doc_ext === "png" ||
                                                            res.doc_ext === "webp"
                                                        )) && (
                                                            <span
                                                                onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid, openDocument)}
                                                                className="pointer colorThemeBlue"
                                                            >
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        )}

                                                    &nbsp;&nbsp;
                                                    {res.doc_aws == 1 ? (
                                                        <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />

                                                        </span>
                                                    ) :
                                                        <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />
                                                        </span>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Payment Details</h5>
                        </Col>
                    </Row>
                    {reqAddPaymentFinal * 1 === 0 ?
                        <>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Bank </Form.Label>
                                        <Form.Select
                                            value={reqPayBankCode}
                                            onChange={(e) => handleReqPayBank(e.target.value, e.target.options[e.target.selectedIndex].text)}  >
                                            {ddReqPayBankOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Bank Reference No</Form.Label>
                                        <Form.Control type="text" placeholder="Reference Number"
                                            maxLength={50} autoComplete="off"
                                            value={reqPayBankRefNo}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqPayBankRefNo)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>INR Amount</Form.Label>
                                        <Form.Control type="text" placeholder="INR Amount"
                                            maxLength={10} autoComplete="off"
                                            value={reqPayBankAmnt}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqPayBankAmnt)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Date<span className="mandatory">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={reqPayBankDate}
                                            onChange={(date) => setReqPayBankDate(date)}
                                            isClearable={!isAddPaymentFinal()}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            disabled={isAddPaymentFinal()}
                                            customInput={
                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddPayment()} >Add</Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>

                        : null
                    }

                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={
                                reqTotalReceived * 1 !== reqTotalReceivable * 1 ? "divDanger" : "divNormal"
                            }
                            >
                                Total Received : <b>{reqTotalReceived}</b>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>Bank</td>
                                        <td>Reference No</td>
                                        <td>Amount</td>
                                        <td>Date</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>
                                                {
                                                    (reqAddPaymentFinal * 1 === 0 && res.paygateway * 1 === 0) ?
                                                        <>
                                                            <div className="colorThemeBlue">
                                                                <span className="handCursor" onClick={(e) => btnDeletePaymentClick(res.srno, res.amnt)}>
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </span>
                                                            </div>
                                                        </>
                                                        : null
                                                }
                                            </td>
                                            <td className='divHide'>{res.srno}</td>
                                            <td>{res.bank + ' : ' + res.banknm}</td>
                                            <td>{res.refno}</td>
                                            <td>{res.amnt}</td>
                                            <td>{(res.paydate).split('-').reverse().join('/')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Forex : {(reqData.req_sellrate * reqData.req_quantity).toFixed(2)}&nbsp;&nbsp;&nbsp;
                            TCS : {reqData.req_tcs}&nbsp;&nbsp;&nbsp;
                            GST : {reqData.req_gst}&nbsp;&nbsp;&nbsp;
                            Bank Charges : {reqData.req_bankcharges}&nbsp;&nbsp;&nbsp;
                            Nostro : {reqData.req_nostrocharges}&nbsp;&nbsp;&nbsp;
                            Round off : {reqData.req_roundoff}&nbsp;&nbsp;&nbsp;
                            Total : <b>{reqTotalReceivable}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    {
                        (reqAddDetailsFinal === "0" || reqAddPaymentFinal === "0" || reqDocumentsFinal === "0") ?
                            <Row>
                                <Col xs={6}>
                                    <Form.Group >
                                        <Form.Label>Comment</Form.Label>
                                        <Form.Control type="text" placeholder="Comment" maxLength={100}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                            value={remark} autoComplete="off" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                                    </Form.Group>
                                </Col>
                            </Row>
                            : null
                    }
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    {
                        (reqPurpose === "14" || reqPurpose === "15" || reqPurpose === "19") ? <>
                            <Row>
                                <Col>
                                    <Badge bg="danger" >List of Travellers in excel is mandatory to upload for Tour Purpose.</Badge>
                                </Col>
                            </Row>
                        </> : null
                    }
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                            {
                                (!isAddPaymentFinal() || !isAddDetailsFinal() || !isAddDocumentFinal()) ?
                                    <>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnDraftClick()} >Draft</Button>&nbsp;
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnFinalClick()} >Final</Button>&nbsp;
                                    </>
                                    : null
                            }
                            <Button variant="outline-success" size="sm" onClick={(e) => btnOrderRepClick()} >Order Print</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            {
                                !isAddDetailsFinal() ?
                                    <>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnUnlockCharges()} >Unlock Charges</Button>&nbsp;
                                    </>
                                    : null
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div >
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
     
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
            <Modal
                show={showFetchTransaction}
                onHide={() => setShowFetchTransaction(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title >
                        Backoffice Transaction Details:
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <b>Order No : {backOfficeData.orderNo} </b>
                        </Col>
                        <Col>
                            <b>Order Date : {orderDate.split('-').reverse().join('/')}</b>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>
                                ISD : {backOfficeData.isd}
                            </b>
                        </Col>
                        <Col>
                            <b>Quantity : {backOfficeData.isdQty}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>Remitter : {backOfficeData.clientNm} ({backOfficeData.panNo}) </b>
                        </Col>
                        <Col>
                            <b>
                                Beneficiary : {backOfficeData.beniName}
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={() => autoFillForm()}>Fill Form</Button>&nbsp;
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal
                show={showFetchZenEremit}
                onHide={() => setShowFetchZenEremit(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title >
                        ZenEremit Reference No : {zenRefData.req_refno}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Purpose : <b>{zenRefData.req_purposenm}</b>
                        </Col>
                        <Col>
                            Beneficiary Country : <b>{zenRefData.req_benecountrynm}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Remitter : <b>{zenRefData.req_remittername} {zenRefData.req_pan} </b>
                        </Col>
                        <Col>
                            Address : <b>{zenRefData.req_remitteraddress}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Beneficiary : <b>{zenRefData.req_benename}</b>
                        </Col>
                        <Col>
                            Address : <b>{zenRefData.req_beneadd}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Beneficiary Bank : <b>{zenRefData.req_benebank}</b>
                        </Col>
                        <Col>
                            Beneficiary Acct : <b>{zenRefData.req_benebankacct}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Swift Code : <b>{zenRefData.req_beneswiftcode}</b>
                        </Col>
                        <Col>
                            Beneficiary Bank Address : <b>{zenRefData.req_benebankadd}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={() => autoFillFormZen()}>Fill Form</Button>&nbsp;
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal
                show={showConfirmBox}
                onHide={() => setShowConfirmBox(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Additional Details Final Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Are you sure to lock the Additional Details ? Locked Additional Details can not be modified.
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveAddDetails("F")} >Yes</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => saveAddDetails("D")} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default AddDetails;
